import '@fontsource/noto-sans-jp/400.css'
import '@fontsource/noto-sans-jp/700.css'
import '@fontsource/noto-sans/400.css'
import '@fontsource/noto-sans/700.css'
import './styles/reset.css'
import './styles/pc-viewport-lock.css'
import './styles/mobile-business-motion.scss'
import './styles/hanging-indent.scss'
import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

// 全局 <img> 禁用右键菜单（等同 oncontextmenu="return false"）
document.addEventListener(
  'contextmenu',
  (e) => {
    if (e.target instanceof HTMLImageElement) {
      e.preventDefault()
    }
  },
  true
)
